/* global axios */
import ApiClient from './ApiClient';

class CampaignTemplatesAPI extends ApiClient {
  constructor() {
    super('campaign_templates', { accountScoped: true });
  }

  preview(templateId, contactId = null, customVariables = {}) {
    return axios.post(`${this.url}/${templateId}/preview`, {
      contact_id: contactId,
      custom_variables: customVariables,
    });
  }

  duplicate(templateId, newName = null) {
    return axios.post(`${this.url}/${templateId}/duplicate`, {
      new_name: newName,
    });
  }

  getCategories() {
    return axios.get(`${this.url}/categories`);
  }

  getMostUsed(limit = 10) {
    return axios.get(`${this.url}/most_used`, {
      params: { limit },
    });
  }
}

export default new CampaignTemplatesAPI();
